import { useCallback } from 'react'

export type OrderDirection = 'asc' | 'desc' | null
// common sorting function : DON'T TOUCH IT
export const useSortingFn = <T>(
	orderBy: keyof T | null,
	orderDirection: OrderDirection
) => {
	return useCallback(
		(a: T, b: T): number => {
			if (!orderBy || !orderDirection) return 0

			const valueA = a[orderBy]
			const valueB = b[orderBy]

			let comparison = 0

			if (typeof valueA === 'string' || typeof valueB === 'string') {
				const lowerValA = (valueA as string)?.toLowerCase?.() || ''
				const lowerValB = (valueB as string)?.toLowerCase?.() || ''
				comparison = lowerValA?.localeCompare(lowerValB)
			} else if (valueA instanceof Date || valueB instanceof Date) {
				const timeA = new Date(valueA as Date | string | number).getTime()
				const timeB = new Date(valueB as Date | string | number).getTime()
				comparison = timeA - timeB
			} else if (typeof valueA === 'number' || typeof valueB === 'number') {
				comparison = ((valueA as number) || 0) - ((valueB as number) || 0)
			}

			return orderDirection === 'desc' ? -comparison : comparison
		},
		[orderBy, orderDirection]
	)
}
